<template>
  <a-layout>
    <main-layout v-if="$ui.layout === 'main'"></main-layout>
    <minimal-layout v-else-if="$ui.layout === 'minimal'" style="height: 100%"></minimal-layout>

    <app-dialogs></app-dialogs>
    <app-notifications></app-notifications>
  </a-layout>
</template>

<script>
import AppNotifications from '@/views/Common/Notifications/AppNotifications'
import AppDialogs from '@/views/Common/Dialogs/AppDialogs'
import MinimalLayout from '@/views/Layout/MinimalLayout'
import MainLayout from '@/views/Layout/MainLayout'

export default {
  name: 'App',

  components: {
    MainLayout,
    MinimalLayout,
    AppDialogs,
    AppNotifications,
  },

  mounted () {
    this.$bus.on('api/disconnected', () => {
      if(this.$route.path !== '/login') this.$router.push('/login')
    })

    this.$bus.on('ui/download', file => {
      window.location.href = this.$api.axios.defaults.baseURL + 'download/' + file
    });
  }
}
</script>

<style lang="scss">
@import "./styles/global.scss";
</style>

<i18n>
{
  "en": {
    "disconnected-error": "Your session has expired, please login again."
  },
  "es": {
    "disconnected-error": "Tu sesión ha caducado, vuelve a iniciar sesión"
  },
  "fr": {
    "disconnected-error": "Votre session a expiré, veuillez vous reconnecter"
  },
  "it": {
    "disconnected-error": "La tua sessione è scaduta, accedi di nuovo."
  },
  "pt": {
    "disconnected-error": "A sua sessão expirou, por favor inicie sessão novamente."
  },
  "pl": {
    "disconnected-error": "Twoja sesja wygasła, zaloguj się ponownie."
  }
}
</i18n>